import { getCadenzaTopWindow } from '@disy/lib/iframe';

/**
 * Returns the current frame's `window.location` and can be mocked in tests.
 *
 * Mocking/Spying on the location is otherwise not possible.
 * @see https://github.com/jsdom/jsdom/issues/3492
 */
export function getLocation() {
  return window.location;
}

/**
 * Returns the top window's `window.location` and can be mocked in tests.
 */
export function getTopLocation() {
  return getCadenzaTopWindow().location;
}
